export const GET_CAREER_DEGREE_LEVELS = 'GET_CAREER_DEGREE_LEVELS';
export const GET_CAREER_DEGREE_LEVEL_BY_ID = 'GET_CAREER_DEGREE_LEVEL_BY_ID';
export const UPDATE_CAREER_DEGREE_LEVEL = 'UPDATE_CAREER_DEGREE_LEVEL';
export const DELETE_CAREER_DEGREE_LEVEL = 'DELETE_CAREER_DEGREE_LEVEL';
export const CREATE_CAREER_DEGREE_LEVEL = 'CREATE_CAREER_DEGREE_LEVEL';
